export default __webpack_public_path__ + "static/media/p7-16.319233b4.png";